<template>
  <div class="box">
    <div
      v-if="
        $store.state.role === 'school-role' ||
        $store.state.role === 'teacher-role' ||
        $store.state.role === 'audit-role' ||
        $store.state.role === 'education-guide-role' ||
        $store.state.role === 'education-role'
      "
    >
      <school-project-list module-type="brand" />
    </div>
    <div v-if="$store.state.role === 'expert-role'">
      <expert-table-view
        :columns="expertColumns"
        :pagination="pagination"
        :timestampStartTime="timestampStartTime"
        :timestampEndTime="timestampEndTime"
        :reviewStartTimestamp="reviewStartTimestamp"
        :reviewEndTimestamp="reviewEndTimestamp"
        :reviewStartTime="reviewStartTime"
        :reviewEndTime="reviewEndTime"
        :data="expertData"
        :wokrName="'特色文化育人品牌'"
        :applyCount="applyCount"
        :schoolCount="schoolCount"
        @goQuery="goQuery"
        @updataInfo="updataInfo"
        @getApplyZjApplyList="getApplyZjApplyList"
        @reviewSubmit="reviewSubmit"
        type="educationalBrand"
      ></expert-table-view>
    </div>
    <!-- 教育局（education-role）已改用卡片总览 school-project-list，见上方 school-role 分支 -->
    <div v-if="$store.state.role === 'score-role'">
      <education-table
        :dataList="dataList"
        :pagination="pagination"
        :loading="loading"
        :columns="educatioColumns"
        :wokrName="'特色文化育人品牌'"
        :applyCount="applyCount"
        :schoolCount="schoolCount"
        @editInfo="editInfo"
        @lxApplyExportZip="lxApplyExportZip"
        @getLxApplyjyjApplylist="getLxApplyjyjApplylist"
        type="educationalBrand"
      />
    </div>
  </div>
</template>

<script>
import {
  lxApplyApplylist,
  applyDateView,
  lxApplyApplyDelete,
  lxApplyjApplylist,
  expertDateView,
  lxApplyZjApplyList,
  lxApplyExportZip,
  lxApplytApplylist,
} from "../../api/index";
import { getApplyOverviewList } from "../../api/auditTask.js";
import tableView from "../../components/common/tableView.vue";
import expertTableView from "../../components/common/expertTableView.vue";
import { getTsFormatDate } from "../../utils/time";
import educationTable from "../../components/common/educationTable.vue";
import auditTable from "../../components/common/auditTable.vue";
import SchoolProjectList from "../../components/projectShell/SchoolProjectList.vue";
export default {
  name: "",
  components: {
    tableView,
    expertTableView,
    educationTable,
    auditTable,
    SchoolProjectList,
  },
  props: {},
  data() {
    return {
      // 教育局
      educatioColumns: [
        {
          title: "序号",
          dataIndex: "sequenceNumber",
          id: "sequenceNumber",
          align: "center",
          scopedSlots: { customRender: "sequenceNumber" },
          width: 70,
        },
        {
          title: "学校名称",
          dataIndex: "realname",
          id: "realname",
          align: "center",
          width: 180,
        },
        {
          title: "品牌名称",
          dataIndex: "name",
          id: "name",
          align: "center",
          width: 250,
        },
        {
          title: "审核状态",
          dataIndex: "auditState",
          id: "auditState",
          align: "center",
          scopedSlots: { customRender: "auditState" },
          width: 150,
        },
        {
          title: "建设日期",
          dataIndex: "foundTime",
          id: "foundTime",
          align: "center",
          width: 150,
        },
        // {
        //   title: "是否非遗",
        //   dataIndex: "izCheritage_dictText",
        //   id: "izCheritage_dictText",
        //   align: "center",
        //   width: 130,
        // },
        // {
        //   title: "品牌模式",
        //   dataIndex: "brandMode",
        //   id: "brandMode",
        //   align: "center",
        //   width: 100,
        // },
        {
          title: "申报年份",
          dataIndex: "applyYear",
          id: "applyYear",
          align: "center",
          width: 100,
        },
        // {
        //   title: "品牌基地",
        //   dataIndex: "baseNum",
        //   id: "baseNum",
        //   align: "center",
        //   scopedSlots: { customRender: "ppjd" },
        //   width: 100,
        // },
        {
          title: "品牌团队",
          dataIndex: "groupNum",
          id: "groupNum",
          align: "center",
          scopedSlots: { customRender: "xtdcy" },
          width: 100,
        },
        // {
        //     title: "资金",
        //     dataIndex: "totalAmount",
        //     id: "totalAmount",
        //     align: "center",
        //     scopedSlots: { customRender: "zjyl" },
        //     width: 100,
        // },
        {
          title: "品牌活动",
          dataIndex: "activityNum",
          id: "activityNum",
          align: "center",
          scopedSlots: { customRender: "pphd" },
          width: 100,
        },
        {
          title: "申报书",
          dataIndex: "declarationName",
          id: "declarationName",
          align: "center",
          scopedSlots: { customRender: "sbs" },
          width: 100,
        },
        {
          title: "操作",
          id: "action",
          align: "center",
          width: 244,
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ],
      // 学校
      columns: [
        {
          title: "序号",
          dataIndex: "sequenceNumber",
          id: "sequenceNumber",
          align: "center",
          scopedSlots: { customRender: "sequenceNumber" },
          width: 70,
        },
        {
          // title: "品牌名称",
          dataIndex: "name",
          slots: { title: "customTitle1" },
          id: "name",
          align: "center",
          width: 250,
        },
        {
          title: "建设日期",
          dataIndex: "foundTime",
          id: "foundTime",
          align: "center",
          width: 150,
        },
        // {
        //   title: "是否非遗",
        //   dataIndex: "izCheritage_dictText",
        //   id: "izCheritage_dictText",
        //   align: "center",
        //   width: 100,
        // },
        {
          // title: "审核状态",
          slots: { title: "shzt" },
          dataIndex: "auditState",
          id: "auditState",
          align: "center",
          scopedSlots: { customRender: "auditState" },
          width: 150,
        },
        // {
        //   title: "品牌模式",
        //   dataIndex: "brandMode",
        //   id: "brandMode",
        //   align: "center",
        //   width: 100,
        // },
        {
          title: "申报年份",
          dataIndex: "applyYear",
          id: "applyYear",
          align: "center",
          width: 100,
        },
        // {
        //   title: "品牌基地",
        //   dataIndex: "baseNum",
        //   id: "baseNum",
        //   align: "center",
        //   scopedSlots: { customRender: "ppjd" },
        //   width: 100,
        // },
        {
          title: "品牌团队",
          dataIndex: "groupNum",
          id: "groupNum",
          align: "center",
          scopedSlots: { customRender: "xtdcy" },
          width: 100,
        },
        // {
        //     title: "资金",
        //     dataIndex: "totalAmount",
        //     id: "totalAmount",
        //     align: "center",
        //     scopedSlots: { customRender: "zjyl" },
        //     width: 100,
        // },
        {
          title: "品牌活动",
          dataIndex: "activityNum",
          id: "activityNum",
          align: "center",
          scopedSlots: { customRender: "pphd" },
          width: 100,
        },
        {
          title: "申报书",
          dataIndex: "declarationName",
          id: "declarationName",
          align: "center",
          scopedSlots: { customRender: "sbs" },
          width: 100,
        },
        {
          // title: "操作",
          slots: { title: "operate" },
          id: "action",
          align: "center",
          width: 340,
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ],
      // 专家
      expertColumns: [
        {
          title: "序号",
          dataIndex: "sequenceNumber",
          id: "sequenceNumber",
          align: "center",
          scopedSlots: { customRender: "sequenceNumber" },
          width: 70,
        },
        {
          title: "特色文化育人品牌名称",
          dataIndex: "name",
          key: "name",
          align: "center",
          width: 220,
        },
        {
          title: "学校",
          dataIndex: "realname",
          key: "realname",
          align: "center",
          width: 220,
        },
        {
          title: "项目负责人",
          dataIndex: "principals",
          key: "principals",
          align: "center",
          width: 120,
        },
        {
          title: "联系电话",
          dataIndex: "phone",
          key: "phone",
          align: "center",
          width: 120,
        },
        {
          title: "资料完整",
          dataIndex: "applyFilesFull",
          id: "applyFilesFull",
          align: "center",
          scopedSlots: { customRender: "applyFilesFull" },
          width: 100,
        },
        {
          title: "分数",
          dataIndex: "score",
          key: "score",
          align: "center",
          width: 80,
        },
        // {
        //   title: "评审表",
        //   dataIndex: "scoreFile",
        //   key: "scoreFile",
        //   align: "center",
        //   scopedSlots: { customRender: "applyScoreFile" },
        //   width: 80,
        // },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 100,
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ],
      isShowView: false,
      startTime: "",
      endTime: "",
      dataList: [],
      loading: true,
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10, //每页中显示10条数据
      },
      timestampStartTime: "",
      timestampEndTime: "",
      btnShow: true,
      reviewStartTime: "",
      reviewEndTime: "",
      reviewStartTimestamp: "",
      reviewEndTimestamp: "",
      expertData: [],
      applyCount: 0,
      schoolCount: 0,
      spinning: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    console.log("this.$store.state.role", this.$store.state.role);
    // 学校/教师/审核员列表改由 SchoolProjectList 自行拉取，此处不再请求
    if (
      this.$store.state.role === "score-role" ||
      this.$store.state.role === "education-role"
    ) {
      this.getLxApplyjyjApplylist({
        page: 1,
        size: 10,
      });
    }
    if (this.$store.state.role === "expert-role") {
      this.getApplyZjApplyList({
        page: 1,
        size: 10,
      });
      this.getexpertDateView();
    }
    // education-guide-role 列表已改由 SchoolProjectList 自行拉取，此处不再请求
  },
  methods: {
    updataInfo() {
      this.getApplyZjApplyList({
        page: 1,
        size: 10,
      });
    },
    // 学校
    getLxApplyApplylist(pagination) {
      this.loading = true;
      let data = {
        applyType: "",
        pageNo: pagination.page,
        pageSize: pagination.size,
      };
      if (pagination.realname != "") {
        data.schoolName = pagination.realname;
      }
      if (pagination.name != "") {
        data.name = pagination.name;
      }
      if (pagination.applyYear != "") {
        data.applyYear = pagination.applyYear;
      }
      if (pagination.auditState != "") {
        data.auditState = pagination.auditState;
      }
      if (this.$route.name === "szStudio") {
        data.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        data.applyType = 2;
      } else {
        data.applyType = 3;
      }
      lxApplyApplylist(data).then((res) => {
        if (res.code === 0) {
          let data = res.result.records;
          if (data) {
            this.dataList = data;
            this.pagination.total = res.result.total;
          }
        }
        this.loading = false;
      });
    },
    // 教育局
    getLxApplyjyjApplylist(pagination) {
      this.loading = true;
      let data = {
        applyType: "",
        pageNo: pagination.page,
        pageSize: pagination.size,
        roleCode: "education",
      };
      if (pagination.realname != "") {
        data.schoolName = pagination.realname;
      }
      if (pagination.name != "") {
        data.name = pagination.name;
        data.keyword = pagination.name;
      }
      if (pagination.applyYear != "") {
        data.applyYear = pagination.applyYear;
      }
      if (pagination.auditState != "") {
        data.auditState = pagination.auditState;
      }
      if (this.$route.name === "szStudio") {
        data.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        data.applyType = 2;
      } else {
        data.applyType = 3;
      }
      // 评分角色参数
      if (this.$store.state.role === "score-role") {
        data.auditState = 2;
      }
      // 教育厅/局统一走 getApplyOverviewList，后端按 roleCode=education 限制只看
      // 待教育局审核(1+level2)/审核通过(2)/教育局驳回(3+level2)
      getApplyOverviewList(data).then((res) => {
        if (res.code === 0 || res.code === 200) {
          let data = res.result.records;
          if (data) {
            this.dataList = data;
            this.pagination.total = res.result.total;
          }
        }
        this.loading = false;
      });
    },
    // 获取专家列表
    getApplyZjApplyList(pagination) {
      let data = {
        applyType: "",
        pageNo: pagination.page,
        pageSize: pagination.size,
      };
      if (pagination.realname != "") {
        data.schoolName = pagination.realname;
      }
      if (pagination.name != "") {
        data.name = pagination.name;
      }
      if (pagination.principals != "") {
        data.principals = pagination.principals;
      }
      if (pagination.Integrity != "") {
        data.applyFilesFull = pagination.Integrity;
      }
      if (this.$route.name === "szStudio") {
        data.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        data.applyType = 2;
      } else {
        data.applyType = 3;
      }
      lxApplyZjApplyList(data).then((res) => {
        if (res.code === 200) {
          this.expertData = res.result.pageList.records;
          this.applyCount = res.result.applyCount;
          this.schoolCount = res.result.schoolCount;
          this.pagination.total = res.result.pageList.total;
        }
      });
    },
    deleteApply(id) {
      lxApplyApplyDelete({ id, applyId: id }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message);
          this.getLxApplyApplylist({
            page: 1,
            size: 10,
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取申报时间
    getapplyDateView() {
      applyDateView().then((res) => {
        if (res.code == 200) {
          this.timestampStartTime = res.result.startTime;
          this.timestampEndTime = res.result.endTime;
          var startTime = parseInt(res.result.startTime);
          var endTime = parseInt(res.result.endTime);
          this.startTime = getTsFormatDate(startTime);
          this.endTime = getTsFormatDate(endTime);
          var date1 = new Date();
          var timestamp = Date.parse(date1);
          if (timestamp < this.timestampStartTime) {
            this.btnShow = false;
          } else if (timestamp > this.timestampEndTime) {
            this.btnShow = false;
          } else if (
            timestamp > this.timestampStartTime &&
            timestamp < this.timestampEndTime
          ) {
            this.btnShow = true;
          }
        }
      });
    },
    goQuery(query) {
      const pagination = {
        page: 1,
        size: 10,
        name: query.name,
        principals: query.principals,
        schoolName: query.schoolName,
        Integrity: query.Integrity,
      };
      this.getApplyZjApplyList(pagination);
    },
    goQuerySchool(query) {
      const pagination = {
        page: 1,
        size: 10,
        name: query.name,
        principals: query.principals,
        Integrity: query.Integrity,
      };
      this.getLxApplyApplylist(pagination);
    },
    // 获取评审时间
    getexpertDateView() {
      expertDateView().then((res) => {
        if (res.code == 200) {
          var startTime = parseInt(res.result.startTime);
          var endTime = parseInt(res.result.endTime);
          this.reviewStartTime = getTsFormatDate(startTime);
          this.reviewEndTime = getTsFormatDate(endTime);
          this.reviewStartTimestamp = res.result.startTime;
          this.reviewEndTimestamp = res.result.endTime;
        }
      });
    },
    editInfo(params, type) {
      // params.type = type;
      // this.$router.push({ name: `${this.$route.name}DataUpload`, params });
      params.type = type;
      let applyType = 0;
      if (this.$route.name === "szStudio") {
        applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        applyType = 2;
      } else {
        applyType = 3;
      }
      let news = "edit";
      if (params.type) {
        news = params.type;
      }
      // console.log(params,type,"想要的");
      this.$router.push({
        name: `${this.$route.name}DataUpload`,
        query: { id: params.id, applyType: applyType, new: news },
      });
    },
    lxApplyExportZip(data) {
      this.spinning = true;
      let params = {};
      if (this.$route.name === "szStudio") {
        params.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        params.applyType = 2;
      } else {
        params.applyType = 3;
      }
      if (data.schoolName != "") {
        params.schoolName = data.schoolName;
      }
      if (data.workroomName != "") {
        params.name = data.workroomName;
      }
      if (data.projectPrincipal != "") {
        params.principals = data.projectPrincipal;
      }
      if (data.Integrity != "") {
        params.applyFilesFull = data.Integrity;
      }
      lxApplyExportZip(params).then((res) => {
        let url = window.URL.createObjectURL(
          new Blob([res], { type: "application/zip" })
        );
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        let fileName = "";
        if (this.$route.name === "szStudio") {
          fileName = "思政工作室";
        } else if (this.$route.name === "educationalBrand") {
          fileName = "特色文化育人品牌";
        } else {
          fileName = "思政微课";
        }
        link.setAttribute("download", `${fileName}遴选作品批量下载` + ".zip");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(url); //释放掉blob对象
        this.spinning = false;
      });
    },
    // 评审提交回显
    reviewSubmit() {
      this.getApplyZjApplyList({
        page: 1,
        size: 10,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 19px 26px;
  min-height: 450px;
}
</style>
